import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Card,
    CardActionArea,
    CardContent,
    Box,
    Typography,
    CardHeader,
    Tooltip,
} from "@mui/material";

import { connect } from "react-redux";
import tmsActions from "../../../../actions/tmsActions";
import { getAccomplishments } from "../../../../reducers";
import dayjs from "dayjs";
import SkillChip from "../SkillChip";
import TMSAvatar from "../TMSAvatar";

const appCode = "C-TMS";

const MyAccomplishmentsCard = ({ accomplishments, getAccomplishments }) => {
    useEffect(() => {
        getAccomplishments(appCode);
    }, [getAccomplishments]);

    let mySkills = [];

    if (accomplishments) {
        accomplishments.forEach((accomplishment) => {
            const skill = {
                name: accomplishment.skill.name,
                expired: dayjs().isAfter(accomplishment.dateExpired, "day"),
            };
            mySkills.push(skill);
        });
    }

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={"/tms/accomplishments"}
                centerRipple
            >
                <CardHeader
                    disableTypography
                    avatar={
                        <Tooltip title="View your accomplishments" arrow>
                            <TMSAvatar type="accomplishment" />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            Accomplishments
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            {mySkills.length} acquired skills
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <Box className="card-content">
                    {mySkills.length < 1
                        ? null
                        : mySkills.map((row, index) => (
                              <SkillChip
                                  label={row.name}
                                  acquired
                                  expired={row.expired}
                                  key={index}
                              />
                          ))}
                </Box>
            </CardContent>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    accomplishments: getAccomplishments(state),
});

const mapDispatchToProps = {
    getAccomplishments: tmsActions.getAccomplishments,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyAccomplishmentsCard);
